export const CHECK_EXCEPTIONS_CONTAINER_TAG_NAME = 'check-exceptions-container';
